import React, { useState } from 'react';
import Styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Applet, { AppletContainer } from '../../Components/Applet';
import WelcomeToDavie from '../../Components/WelcomeToDavie';
import { useAuth } from '../../Contexts/AuthContext';
import { useProfile } from '../../Contexts/UserProfileContext';

const LoginContainer = Styled.div`
margin-top: 100px;
width: 100%;
margin-bottom: 100px;
height: 800px;
`;

const FormName = Styled.div`
text-align: left;
letter-spacing: 0.77px;
color: #000000DE;
opacity: 1;
padding-left: 15px;
padding-top: 11px;
`;

const LoginTextFieldContainer = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 25px;
  margin-left: 15px;
  margin-right: 15px;
`;

const LoginButton = Styled(Button)`
background: #2e69fe 0% 0% no-repeat padding-box !important;
box-shadow: 0px 3px 3px #00000061;
border-radius: 4px;
opacity: 1;
width: 100%;
  &.MuiButton-contained.Mui-disabled {
    color: #fafbf7;
  }
  :disabled {
    background: #9b9b9d 0% 0% no-repeat padding-box !important;
  }
`;

const WelcomeText = Styled.div`
width: 426px;
margin-bottom: 30px;
text-align: center;
letter-spacing: 0px;
opacity: 1;
margin-left: auto;
margin-right: auto;

`;

const UpdatePassword = () => {
    const [values, setValues] = useState({
        password: '',
        showPassword: false,
        isLoading: false,
        error: false,
    });

    const initialErrorValue = {
        code: '',
        message: '',
        input: '',
    };
    const [error, setError] = useState({ ...initialErrorValue });
    const [loading, setLoading] = useState(false);
    const { updatePassword, currentUser, getSignInMethods, logout } = useAuth();
    const { email, accessToken: token } = { ...currentUser };
    const { profile } = useProfile();
    const history = useHistory();

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const updateUserPassword = async () => {
        try {
            setValues({ ...values, isLoading: true });
            await updatePassword(values.password).then(() => {
                setValues({ ...values, isLoading: false });
            });
        } catch (err) {
            setValues({ ...values, isLoading: false, error: err?.message || 'Something went wrong' });
        }
    };

    const buttonIsDisabled = values.password.length < 6;
    return (
        <LoginContainer>
            <WelcomeToDavie />
            <AppletContainer>
                <WelcomeText>For security, please update your password.</WelcomeText>
                <Applet>
                    <FormName>Update Password</FormName>
                    <LoginTextFieldContainer>
                        <TextField
                            error={buttonIsDisabled}
                            helperText={
                                buttonIsDisabled ? 'Password must be at least 6 characters.' : null
                            }
                            id="password-login"
                            label="Password"
                            type={values.showPassword ? 'text' : 'password'}
                            defaultValue={values.password}
                            onChange={handleChange('password')}
                            variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {values.showPassword ? (
                                                <Visibility />
                                            ) : (
                                                <VisibilityOff />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <br />
                        <LoginButton
                            onClick={() => updateUserPassword()}
                            variant="contained"
                            color="primary"
                            disabled={buttonIsDisabled}
                        >
                            {values.isLoading ? (
                                <CircularProgress
                                    style={{ height: '20px', width: '20px', color: 'white' }}
                                    color="primary"
                                />
                            ) : (
                                'Update Password'
                            )}
                        </LoginButton>
                        <br />
                    </LoginTextFieldContainer>
                </Applet>
            </AppletContainer>
        </LoginContainer>
    );
};

export default UpdatePassword;
